var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "asd__fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDatepicker,
            expression: "showDatepicker"
          },
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.handleClickOutside,
            expression: "handleClickOutside"
          }
        ],
        staticClass: "asd__wrapper",
        class: _vm.wrapperClasses,
        style: _vm.showFullscreen ? undefined : _vm.wrapperStyles,
        attrs: { id: _vm.wrapperId }
      },
      [
        _vm.showFullscreen
          ? _c("div", { staticClass: "asd__mobile-header asd__mobile-only" }, [
              _c(
                "button",
                {
                  staticClass: "asd__mobile-close",
                  attrs: { "aria-label": _vm.ariaLabels.closeDatepicker },
                  on: { click: _vm.closeDatepicker }
                },
                [
                  _vm.$slots["close-icon"]
                    ? _vm._t("close-icon")
                    : _c(
                        "div",
                        {
                          staticClass: "asd__mobile-close-icon",
                          attrs: { "aria-hidden": "true" }
                        },
                        [_vm._v("X")]
                      )
                ],
                2
              ),
              _vm._v(" "),
              _c("h3", [
                _vm._v(_vm._s(_vm.mobileHeader || _vm.mobileHeaderFallback))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "asd__datepicker-header" },
          [
            _c(
              "div",
              {
                staticClass:
                  "asd__change-month-button asd__change-month-button--previous"
              },
              [
                _c(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      "aria-label": _vm.ariaLabels.previousMonth
                    },
                    on: { click: _vm.previousMonth }
                  },
                  [
                    _vm.$slots["previous-month-icon"]
                      ? _vm._t("previous-month-icon")
                      : _c("svg", { attrs: { viewBox: "0 0 1000 1000" } }, [
                          _c("path", {
                            attrs: {
                              d:
                                "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z"
                            }
                          })
                        ])
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "asd__change-month-button asd__change-month-button--next"
              },
              [
                _c(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      "aria-label": _vm.ariaLabels.nextMonth
                    },
                    on: { click: _vm.nextMonth }
                  },
                  [
                    _vm.$slots["next-month-icon"]
                      ? _vm._t("next-month-icon")
                      : _c("svg", { attrs: { viewBox: "0 0 1000 1000" } }, [
                          _c("path", {
                            attrs: {
                              d:
                                "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"
                            }
                          })
                        ])
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.showMonths, function(month, index) {
              return _c(
                "div",
                {
                  key: month,
                  staticClass: "asd__days-legend",
                  style: [
                    _vm.monthWidthStyles,
                    { left: _vm.width * index + "px" }
                  ]
                },
                _vm._l(_vm.daysShort, function(day) {
                  return _c(
                    "div",
                    { key: day, staticClass: "asd__day-title" },
                    [_vm._v(_vm._s(day))]
                  )
                }),
                0
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "asd__inner-wrapper", style: _vm.innerStyles },
          [
            _c(
              "transition-group",
              { attrs: { name: "asd__list-complete", tag: "div" } },
              _vm._l(_vm.months, function(month, monthIndex) {
                return _c(
                  "div",
                  {
                    key: month.firstDateOfMonth,
                    staticClass: "asd__month",
                    class: {
                      hidden: monthIndex === 0 || monthIndex > _vm.showMonths
                    },
                    style: _vm.monthWidthStyles
                  },
                  [
                    _c("div", { staticClass: "asd__month-name" }, [
                      _vm.showMonthYearSelect
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: month.monthName,
                                  expression: "month.monthName"
                                },
                                {
                                  name: "resize-select",
                                  rawName: "v-resize-select"
                                }
                              ],
                              staticClass: "asd__month-year-select",
                              attrs: {
                                tabindex:
                                  monthIndex === 0 ||
                                  monthIndex > _vm.showMonths
                                    ? -1
                                    : 0
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      month,
                                      "monthName",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.updateMonth(
                                      monthIndex,
                                      month.year,
                                      $event
                                    )
                                  }
                                ]
                              }
                            },
                            _vm._l(_vm.monthNames, function(monthName, idx) {
                              return _c(
                                "option",
                                {
                                  key: "month-" + monthIndex + "-" + monthName,
                                  attrs: {
                                    disabled: _vm.isMonthDisabled(
                                      month.year,
                                      idx
                                    )
                                  },
                                  domProps: { value: monthName }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(monthName) +
                                      "\n                            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _c("span", [_vm._v(_vm._s(month.monthName))]),
                      _vm._v(" "),
                      _vm.showMonthYearSelect
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: month.year,
                                  expression: "month.year"
                                }
                              ],
                              staticClass: "asd__month-year-select",
                              attrs: {
                                tabindex:
                                  monthIndex === 0 ||
                                  monthIndex > _vm.showMonths
                                    ? -1
                                    : 0
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      month,
                                      "year",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.updateYear(
                                      monthIndex,
                                      month.monthNumber - 1,
                                      $event
                                    )
                                  }
                                ]
                              }
                            },
                            [
                              _vm.years.indexOf(month.year) === -1
                                ? _c(
                                    "option",
                                    {
                                      key:
                                        "month-" + monthIndex + "-" + _vm.year,
                                      attrs: { disabled: true },
                                      domProps: { value: month.year }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(month.year) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.years, function(year) {
                                return _c(
                                  "option",
                                  {
                                    key: "month-" + monthIndex + "-" + year,
                                    domProps: { value: year }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(year) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _c("span", [_vm._v(_vm._s(month.year))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass: "asd__month-table",
                        attrs: { role: "presentation" }
                      },
                      [
                        _c(
                          "tbody",
                          _vm._l(month.weeks, function(week, index) {
                            return _c(
                              "tr",
                              { key: index, staticClass: "asd__week" },
                              _vm._l(week, function(ref, index) {
                                var fullDate = ref.fullDate
                                var dayNumber = ref.dayNumber
                                return _c(
                                  "td",
                                  {
                                    key: index + "_" + dayNumber,
                                    ref: "date-" + fullDate,
                                    refInFor: true,
                                    staticClass: "asd__day",
                                    class: {
                                      "asd__day--enabled": dayNumber !== 0,
                                      "asd__day--empty": dayNumber === 0,
                                      "asd__day--disabled": _vm.isDisabled(
                                        fullDate
                                      ),
                                      "asd__day--selected":
                                        fullDate &&
                                        (_vm.selectedDate1 === fullDate ||
                                          _vm.selectedDate2 === fullDate),
                                      "asd__day--in-range": _vm.isInRange(
                                        fullDate
                                      ),
                                      "asd__day--today":
                                        fullDate && _vm.isToday(fullDate),
                                      "asd__selected-date-one":
                                        fullDate &&
                                        fullDate === _vm.selectedDate1,
                                      "asd__selected-date-two":
                                        fullDate &&
                                        fullDate === _vm.selectedDate2
                                    },
                                    style: _vm.getDayStyles(fullDate),
                                    attrs: {
                                      "data-date": fullDate,
                                      tabindex:
                                        _vm.isDateVisible(fullDate) &&
                                        _vm.isSameDate(
                                          _vm.focusedDate,
                                          fullDate
                                        )
                                          ? 0
                                          : -1,
                                      "aria-label": _vm.isDateVisible(fullDate)
                                        ? _vm.getAriaLabelForDate(fullDate)
                                        : false
                                    },
                                    on: {
                                      mouseover: function() {
                                        _vm.setHoverDate(fullDate)
                                      }
                                    }
                                  },
                                  [
                                    dayNumber
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "asd__day-button",
                                            attrs: {
                                              type: "button",
                                              tabindex: "-1",
                                              date: fullDate,
                                              disabled: _vm.isDisabled(fullDate)
                                            },
                                            on: {
                                              click: function() {
                                                _vm.selectDate(fullDate)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(dayNumber) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              }),
                              0
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.mode !== "single" && _vm.showActionButtons
          ? _c(
              "div",
              {},
              [
                _c(
                  "b-button-group",
                  { staticClass: "mb-4" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { type: "button" },
                        on: { click: _vm.closeDatepickerCancel }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.texts.cancel) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        ref: "apply-button",
                        attrs: { type: "button", variant: "warning" },
                        on: { click: _vm.apply }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.texts.apply) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }